import { NgModule } from '@angular/core';
import { provideConfig } from '../../../core/config/config-providers';

@NgModule({
  providers: [
    provideConfig({
      api: {
        endpoints: {
          adminSessionHistory: 'admin/history/sessions',
          // Agent-desktop uploaded logs (SYSTEM_ADMIN reads) and a profile's agent-desktop config.
          // Also declared in the other config module: the Audit drill-down (sessions-tab) is mounted
          // on both the admin dashboard and System Admin → Security.
          agentLogList: 'agent-logs',
          agentLogDetail: 'agent-logs/${logId}',
          agentLogDownload: 'agent-logs/${logId}/download',
          profileAgentDesktop: 'admin/profile/${profileId}/agent-desktop',
          adminAuditHistory: 'admin/history/audit',
          adminActiveUsers: 'admin/history/active-users',
          adminOpenBatches: 'admin/batches/open',
          adminGateways: 'admin/gateways',
          adminRecentTransactions: 'admin/transactions/recent',
          adminAchIngestions: 'admin/ach/ingestions',
          adminAchIngestionSummary: 'admin/ach/ingestions/summary',
          adminAchIngestionRequeue: 'admin/ach/ingestions/${ingestionId}/requeue',
          adminAchIngestionClearChecksum: 'admin/ach/ingestions/${ingestionId}/clear-checksum',
          adminAchIngestionBulkRequeue: 'admin/ach/ingestions/requeue',
          adminAchIngestionBulkReprocess: 'admin/ach/ingestions/reprocess',
          adminAchIngestionDetail: 'admin/ach/ingestions/${ingestionId}',
          adminAchIngestionJob: 'admin/ach/ingestion-job',
          adminAchIngestionJobSetup: 'admin/ach/ingestion-job/setup',
          // Paya ACH ingestion processing settings + repair actions (SYSTEM_ADMIN).
          adminAchSettings: 'admin/ach/settings',
          adminAchPromoteReturns: 'admin/ach/promote-returns',
          adminAchRebuildCurrentState: 'admin/ach/rebuild-current-state',
          adminAchPurgeRerun: 'admin/ach/profiles/${profileId}/purge-rerun',
          adminProfiles: 'admin/profiles',
          adminProfile: 'admin/profile/${profileId}',
          adminProfileCreate: 'admin/profile',
          adminProfileTemplate: 'admin/profile/<%= profileId %>/template',
          adminProfileTemplates: 'admin/profile-templates',
          adminUsers: 'admin/users',
          adminUser: 'admin/user/${userNumber}',
          adminUserProfiles: 'admin/user/${userNumber}/profiles',
          adminProfileUser: 'admin/profile/${profileId}/user/${userNumber}',
          testEmails: 'test/emails',
          testSendEmail: 'test/emails/send',
          testDateOverride: 'test/date-override',
          testInvoice: 'test/invoice',
          systemEnvironment: 'systems/environment',
        },
      },
    }),
  ],
})
export class AdminDashboardConfigModule {}
